export default [
  {
    name: 'MTBTransactionManage',
    path: '/mtb_transaction_manage',
    component: () =>
      import(
        /* webpackChunkName: "transaction-history" */ './TransactionManage.vue'
      )
  }
]
